import { ALPSData } from "interfaces/dataInterfaces"
import { api } from "./api"

export const alpsApi = api.injectEndpoints({
  endpoints: builder => ({
    getAlps: builder.query<ALPSData, void>({
      query: () => ({ url: "ALPS/Get" }),
      providesTags: () => [{ type: "Alps" as const, id: "DATA" }],
    }),

    updateAlps: builder.mutation<void, Partial<ALPSData>>({
      query: body => ({
        url: "ALPS/Put",
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "Alps", id: "DATA" }],
    }),
  }),
})

export const { useGetAlpsQuery, useUpdateAlpsMutation } = alpsApi
